///<reference path="../../App/plugins/DefinitelyTyped/select2.d.ts"/>
///<reference path="../../App/plugins/DefinitelyTyped/alasql.d.ts"/>
///<reference path="../../App/plugins/DefinitelyTyped/xlsx.d.ts"/>
import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service'

declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;
declare function ExportToExcelNew(item: any[], workSheetName: string, keys: any, Columns?: any): void;
declare function ExportMultiSheetExcel(item: any[], Name: any[], workSheetName: any, keys: any, Columns?: any): void;
declare function tablesToExcel(tables: any[], wsnames: any[], wbname: any, appname: any): void;
@Component({
    templateUrl: './AppViews/AttendanceReport/attendanceReport.html'
})

export class AttendanceReportComponent implements OnInit {
    attendanceItems: any = [];
    attendanceSummary: any[];
    teamItems: any[];
    siteUserItems: any = [];
    userDetail: any;
    selfuser: boolean = true;
    filter: any = {};
    attendanceUser: any = "";
    objSiteUserItem: any = [];
    userStatus: any = [];
    arr: any = [];
    arr2: any = [];
    recordItem: any = [];
    public showLoader = false;
    constant: Constants;
    siteItems:any;


    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private _datepipe: DatePipe) {
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.filter = { 'TeamId': '', IsActive: true, 'UserId': this.userDetail.SiteUserId, 'MonthYear': moment().format('MM/YYYY'), 'LoggedUserId': this.userDetail.SiteUserId , 'SiteId':""};
        this.constant = new Constants();
    }

    ngOnInit() {
        this.userStatus = this.constant.enumSiteUserStatus;
        this.filter.UserId = this.userDetail.SiteUserId;
        this.BindFilters();
        this.getSite();
    }


    ExportItems() {

        var UserId = 0
        if (this.filter.UserId == "") {
            UserId = 0;
        }
        else {
            UserId = this.filter.UserId;
        }
        var TeamId = 0
        if (this.filter.TeamId == "") {
            TeamId = this.userDetail.TeamID;
        }
        else {
            TeamId = this.filter.TeamId;
        }
        this.showLoader = true;
        this._httpService.ajaxPost("Attendance/GetAttendanceReportSummary", { "AttendanceId": 0, "UserId": UserId, "IsActive": this.filter.IsActive, "TeamId": TeamId, "MonthYear": this.filter.MonthYear, "LoggedUserId": this.userDetail.SiteUserId }).subscribe(
            data => {
                this.attendanceSummary = data["AttendanceSummary"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constant.globalError);
            },
            () => {
                var UserId = 0; UserId = this.filter.UserId == "" ? 0 : this.filter.UserId;
                var TeamId = this.filter.TeamId == "" ? this.userDetail.TeamID : this.filter.TeamId;
                this.showLoader = true;
                this._httpService.ajaxPost("Attendance/GetAttendanceReport", { "AttendanceId": 0, "UserId": UserId, "IsActive": this.filter.IsActive, "TeamId": TeamId, "MonthYear": this.filter.MonthYear, "LoggedUserId": this.userDetail.SiteUserId }).subscribe(
                    data => {
                        this.recordItem = [];
                        this.attendanceItems = data["Attendance"];
                        this.attendanceItems.forEach(element => {
                            let objitem = {
                                Date: "", EmpCode: "", SiteName: "", TeamName: "", Name: "", Status: "", InDateTime: ""
                                , OutDateTime: "", Remark: "", InIp: "", InLatitude: "", InLongitude: "", InAddress: ""
                                , MarkedByName: "", ApprovedByName: "", OutIp: "", OutLatitude: "", OutLongitude: "", OutAddress: ""
                            };
                            
                            if (element.Date == null && element.Date == undefined) {
                                objitem.Date = "";
                            }
                            else {
                                objitem.Date = element.Date;
                            }

                            if (element.Emp_Code == null && element.Emp_Code ==undefined) {
                                objitem.EmpCode = "";
                            }
                            else {
                                objitem.EmpCode = element.Emp_Code;
                            }

                            if (element.SiteName == null && element.SiteName ==undefined) {
                                objitem.SiteName = "";
                            }
                            else {
                                objitem.SiteName = element.SiteName;
                            }

                            if (element.TeamName == null && element.TeamName == undefined) {
                                objitem.TeamName = "";
                            }
                            else {
                                objitem.TeamName = element.TeamName;
                            }


                            if (element.Name == null && element.Name == undefined ) {
                                objitem.Name = "";
                            }
                            else {

                                objitem.Name = element.Name;
                            }


                            if (element.Status == null && element.Status  == undefined) {
                                objitem.Status = "";
                            }
                            else {
                                objitem.Status = element.Status;
                            }

                            if (element.InDateTime == null && element.InDateTime== undefined) {
                                objitem.InDateTime = "";
                            }
                            else {
                                objitem.InDateTime = element.InDateTime;
                            }


                            if (element.OutDateTime == null && element.OutDateTime == undefined) {
                                objitem.OutDateTime = "";
                            }
                            else {

                                objitem.OutDateTime = element.OutDateTime;
                            }
                            if (element.InIP == null && element.InIP  == undefined) {
                                objitem.InIp = "";
                            }
                            else {
                                objitem.InIp = element.InIP;
                            }

                            if (element.InLatitude == null && element.InLatitude == undefined) {
                                objitem.InLatitude = "";
                            }
                            else {
                                objitem.InLatitude = element.InLatitude;
                            }
                            if (element.InLongitude == null && element.InLongitude ==undefined ) {
                                objitem.InLongitude = "";
                            }
                            else {
                                objitem.InLongitude = element.InLongitude;
                            }
                            if (element.MarkedByName == null && element.MarkedByName == undefined) {
                                objitem.MarkedByName = "";
                            }
                            else {
                                objitem.MarkedByName = element.MarkedbyName;
                            }
                            if (element.ApprovedByName == null && element.ApprovedByName == undefined) {
                                objitem.ApprovedByName = "";
                            }
                            else {
                                objitem.ApprovedByName = element.ApprovedByName;
                            }
                            if (element.OutIP == null && element.OutIP == undefined) {
                                objitem.OutIp = "";
                            }
                            else {
                                objitem.OutIp = element.OutIP;
                            }
                            if (element.OutLatitude == null && element.OutLatitude ==undefined) {
                                objitem.OutLatitude = "";
                            }
                            else {
                                objitem.OutLatitude = element.OutLatitude;
                            }
                            if (element.OutLongitude == "" && element.OutLongitude == undefined) {
                               objitem.OutLongitude = "";
                            }
                            else {
                                objitem.OutLongitude = element.OutLongitude;
                            }

                            if (element.OutAddress == null &&  element.OutAddress == undefined) {
                                objitem.OutAddress = "";
                            }
                            else {
                                objitem.OutAddress = element.OutAddress;
                            }
                            this.recordItem.push(objitem);
                        }
                        
                        );
                        var newDate = moment(this.filter.MonthYear.split("/")[0]+'/01/'+this.filter.MonthYear.split("/")[1]).format('MMMYYYY');
                        
                        var attendanceItems = this.recordItem;
                        var attendanceSummary = this.attendanceSummary;
                        var opts = [ { sheetid: 'attendanceSummary', header: false },{ sheetid: 'attendanceItems', header: true }];
                        var excelName = "AttendanceReport"+newDate+".xlsx"
                        var res = alasql('SELECT  INTO XLSX("'+excelName+'",?) FROM ?', [opts, [ attendanceSummary,attendanceItems]]);
                        this.showLoader = false;

                    },
                    err => {
                        console.log("GetAttendanceReport Failed");
                        this.showLoader = false;
                        this._sharedService.ShowMessage(this.constant.globalError);
                    },
                    () => {
                        this.showLoader = false;
                    }
                );
               
            });
        //  ExportToExcel(this.attendanceItems, "Attendance",
        //     ["Date", "SiteName","TeamName","Name", "Emp_Code", "Status", "InDateTime", "OutDateTime", "Remarks", "InIP", "InLatitude", "InLongitude", "InAddress", "MarkedbyName", "ApprovedByName", "OutIP", "OutLatitude", "OutLongitude", "OutAddress",],
        //     ["Date", "Site Name","TeamName","Name", "EmpCode", "Status", "InTime", "OutTime", "Remarks", "In IP", "In Latitude", "In Longitude", "In Address", "Marked By", "Approved By", "Out IP", "Out Latitude", "Out Longitude", "Out Address"]);
        // ExportToExcel(this.attendanceSummary, "AttendanceSummary",
        //     ['SiteName', 'Emp_Code', 'Name', 'Present', 'WorkedOnHoliday', 'Absent', 'NotApproved', 'Holiday', 'WeeklyOff', 'Late', 'HalfDay', 'NoOfDays'],
        //     ['Site', 'EmpCode', 'Name', 'Present', 'Worked on Holiday', 'Absent', 'Not Apporoved', 'Holiday', 'WeeklyOff', 'Late', 'Half Day', 'No Of Days']);

    }

  public getSite() {
        this._httpService.ajaxPost('Common/GetSite', null).subscribe(
            data => {
                this.siteItems = data["Site"];
            }
        );
    }

    GetUsers(IsActive: boolean) {
        this.showLoader = true;
        var userId = 0;
        if (this.userDetail.SiteUserId != 0) {
            userId = this.userDetail.SiteUserId;
        }
        this._httpService.ajaxPost('Users/GetUsers', {
            "IsActive": IsActive,
            "Team": this.userDetail.TeamID,
            "UserId": userId
        }).subscribe(
            data => {
                this.siteUserItems = data["Users"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
            );
    }

    GetAttendance(flag: boolean) {
        this.selfuser = flag;
        var UserId = 0; UserId = this.filter.UserId == "" ? 0 : this.filter.UserId;
        var TeamId = this.filter.TeamId == "" ? this.userDetail.TeamID : this.filter.TeamId;
        this.showLoader = true;

        this._httpService.ajaxPost("Attendance/GetAttendanceReport", { "AttendanceId": 0, "UserId": UserId, "IsActive": this.filter.IsActive, "TeamId": TeamId, "MonthYear": this.filter.MonthYear, "siteId":this.filter.SiteId, "LoggedUserId": this.userDetail.SiteUserId }).subscribe(
            data => {
                this.attendanceItems = data["Attendance"];

            },
            err => {
                console.log("GetAttendanceReport Failed");
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constant.globalError);
            },
            () => {
                this.showLoader = false;
                // this._httpService.ajaxPost('Users/GetUsers', {
                //     "IsActive": 1,
                //     "Team": this.userDetail.TeamID,
                //     "UserId": this.userDetail.SiteUserId
                // }).subscribe(
                //     data => {
                //         this.siteUserItems = data["Users"];
                //         if (this.filter.UserId == "") {
                //             this.attendanceUser = this.userDetail.Name;
                //         }
                //         else {
                //             this.attendanceUser = this.siteUserItems.filter((item) => item.SiteUser_Id == this.filter.UserId)[0].Name;
                //         }
                //     },
                //     err => {
                //         this.showLoader = false;
                //         this._sharedService.ShowMessage(this.constant.globalError);
                //     },
                //     () => {
                //         this.showLoader = false;
                //     }
                //     );               
            }
        );
    }

    ngAfterViewInit() {
        $(".datemonthYear").datetimepicker({
            format: 'MM/YYYY',
            maxDate: moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        });
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });
    }

    BindFilters() {
        var userId = 0;
        if (this.userDetail.SiteUserId != 0) {
            userId = this.userDetail.SiteUserId;
        }
        this.showLoader = true;
        this._httpService.ajaxPost('Team/GetAssignedTeam', { "TeamId": this.userDetail.TeamID, "UserId": userId }).subscribe(
            data => {
                this.teamItems = data["AssignedTeam"];
            },
            err => {
                console.log("BindFilters Failed");
                this.showLoader = false;
            },
            () => {
                this._httpService.ajaxPost('Users/GetUsers', {
                    "IsActive": 1,
                    "Team": this.userDetail.TeamID,
                    "UserId": userId
                }).subscribe(
                    data => {
                        this.siteUserItems = data["Users"];
                    },
                    err => {
                        console.log("BindFilters Failed");
                        this.showLoader = false;
                    },
                    () => {
                        this.showLoader = false;
                        this.GetAttendance(true);
                    }
                    );
            }
        );
    }

    public AddUpdateProcessAttendance() {
        this.showLoader = true;
        var UserId = 0
        if (this.filter.UserId == "") {
            UserId = 0;
        }
        else {
            UserId = this.filter.UserId;
        }
        var TeamId = 0
        if (this.filter.TeamId == "") {
            TeamId = this.userDetail.TeamID;
        }
        else {
            TeamId = this.filter.TeamId;
        }
        this._httpService.ajaxPost("Attendance/AddUpdateProcessAttendance", { "UserId": UserId, "TeamId": TeamId, "MonthYear": this.filter.MonthYear, "LoggedUserId": this.userDetail.SiteUserId, "MarkedBy": this.userDetail.SiteUserId }).subscribe(
            data => {
                this._sharedService.ShowMessage(data["Status"].Message);
            },
            err => {
                console.log("BindFilters Failed");
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constant.globalError);

            },
            () => {
                this.GetAttendance(true);
                this.showLoader = false;

            }
        );
    }

    public clearFilter() {
        this.filter.UserId = this.userDetail.SiteUserId;
        this.filter.TeamId = '';
        this.filter.MonthYear = moment().format('MM/YYYY');
        this.filter.SiteId = '';
    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/AttendanceReport/attendanceReport.component.ts
 **/